<template>
  <v-dialog persistent eager content-class="scannerDialog"
            attach=".v-application--wrap"
            v-bind:value="this.getBarcodeScannerState"
  >
    <v-card light class=" three-color-grad searchCard">

        <v-btn
            class="scannerDialogCloseBtn closeBtn leftRounded"
            @click="closeScanner"
        >
          <close-btn/>
        </v-btn>

      <v-container class="scannerHead">
        <v-row v-if="this.getUserRole() !== '2'">
          <v-col cols="9" class="textSize__20">
            Suchen oder scannen
          </v-col>
          <v-col cols="11" style="margin-top: 15px;">
            <v-combobox
                    class="searchField"
                    v-bind:class="[ searchActive ? notExtended : '']"
                    rounded
                    hide-details
                    dense
                    placeholder="Artikelnr. oder Begriff eingeben.."
                    v-model="searchField"
                    :search-input.sync="search"
                    :items="filteredResults"
                    :loading="loadingResults"
                    item-text="description"
                    item-value="id"
                    return-object
                    append-icon=""
                    no-filter
                    @click.stop
                    :suffix="this.termState"
            >
            </v-combobox>
            <!--
            <v-combobox
                class="searchField"
                    v-bind:class="[ searchActive ? notExtended : '']"
                    rounded
                    hide-details
                    dense
                    placeholder="Artikelnr. oder Begriff eingeben.."
                    v-model="searchField"
                    :search-input.sync="search"
                    :items="filteredResults"
                    :loading="loadingResults"
                    item-text="description"
                    item-value="id"
                    return-object
                    append-icon=""
                    attach=".searchField"
                    no-filter
                    @click.stop
                    :suffix="this.termState"
                >
            </v-combobox>
            -->
          </v-col>
            <v-col cols="1" style="margin-top: 15px;">
                <v-btn class="searchBtn float-right"  @click="searchProduct">
                    <magnifyGlass/>
                </v-btn>
            </v-col>
          <v-col cols="6">
            <v-checkbox v-model="queryGTIN" class="selectEAN" label="nach EAN suchen"/>
          </v-col>
        </v-row>

        <v-row v-if="this.getUserRole() === '2'">
          <v-col cols="8" class="textSize__20">
            QR-Code Scannen
          </v-col>
        </v-row>
      </v-container>


      <div id="scannerWrapper" v-if="scannerAvailable">
        <div class="yDelimiter yDelimiterTop">
          <!--
          <v-btn @click="applyTorch">
            Torch
          </v-btn>
          -->
        </div>
        <div class="yDelimiter yDelimiterBottom"/>
        <div class="xDelimiter xDelimiterLeft"/>
        <div class="xDelimiter xDelimiterRight"/>
        <video class="videoContainer"/>
      </div>

      <div class="camNotAvailable" v-if="!scannerAvailable">
        <div>
          <Component :is="require('@/assets/camera_NA.svg')"/>
          <span>Deine Kamera ist aktuell leider nicht verfügbar.</span>
        </div>
      </div>


      <div class="foundArticle" v-if="this.getUserRole() === '2' && detected">
        <v-card class="addToCartCard">
          <v-card-title>
            {{ article.name }}
          </v-card-title>
          <v-container class="addToCartContainer">
            <v-row>
              <v-col cols="12" >
                <v-chip-group
                    class="orderTypeSelector"
                    v-model="selection"
                    mandatory
                >
                  <v-chip value="c">
                    Träger
                  </v-chip>
                  <v-chip value="b">
                    Flasche(n)
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer/>
              <v-col cols="12" md="4" sm="12">
                <v-text-field class="centered-input inputAmountSlot"
                              v-model="counter"
                              filled
                              single-line type="number"
                              append-outer-icon="mdi-plus"
                              @click:append-outer="increment"
                              prepend-icon="mdi-minus"
                              @click:prepend="decrement"
                              dense
                              v-on:blur="checkAmount"
                >
                </v-text-field>
              </v-col>
              <v-spacer/>
            </v-row>
            <v-col cols="6">
              <v-btn class="addToCartFormButton"
                     @click="addAndRestartScanner"
              >
                <span class="pl-3 text--white">Pfand hinzufügen</span>
              </v-btn>
            </v-col>
          </v-container>
        </v-card>
      </div>


    </v-card>



  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import axios from 'axios'
import router from "@/router";
// import Quagga from "quagga";
import Quagga from "@ericblade/quagga2";
// import jaroWinkler from 'jaro-winkler'
import MagnifyGlass from "@/assets/magnifyGlass";
import CloseBtn from "@/assets/closeBtn";


export default {
name: "scannerDialog",
  components: {CloseBtn, MagnifyGlass},

  data:() => {
    return {
      searchField: '',
      loadingResults: false,
      searchResults : [],
      filteredResults: [],
      searchActive: false,
      search: null,
      detected: false,
      gtinArray: [],
      article: null,
      torchActive: false,

      scannerAvailable: true,

      queryGTIN: false,

      counter: 1,
      selection: undefined,

      termCounter: 0,
      requiredChars: 0,
      reqsPassed: false,

      notExtended : 'notExtended'
    }
  },

  methods : {
    isIOS() {
      const ua = window.navigator.userAgent
      return /iP(hone|od|ad)/.test(ua) || (ua.includes('Macintosh') && 'ontouchend' in document)
    },

    isAndroid() {
      return /Android/i.test(window.navigator.userAgent)
    },

    ...mapActions({
    }),

    ...mapGetters({
      getUserRole: "getUserRole"
    }),

    ...mapMutations({
      setBarcodeScannerState: 'setBarcodeScannerState',
      setDepositCollector: 'setDepositCollector',
      setSearchResultsArticles: 'setSearchResultsArticles',
      setCurrentPosition: 'setCurrentPosition'
    }),

    closeScanner() {
      if(this.scannerAvailable) {
        Quagga.stop()
      }
      this.search = ''
      this.searchField = null
      this.queryGTIN = false
      this.detected = false
      this.searchActive = false
      this.searchResults = []
      this.filteredResults = []
      this.termCounter = 0
      this.requiredChars = 0
      this.setBarcodeScannerState()
    },

    searchProducts: function(val) {
      if(!this.queryGTIN) {
        this.requiredChars = 3
        if(val.length >= 3 && this.searchResults.length === 0) {
          this.loadingResults = true
          axios.get('/api/products/search/'+ val)
              .then((result) => {
                if(result.data.length === 0) {
                  this.filteredResults.push({header: 'Keine Produkte gefunden'})
                }
                else {
                  this.searchResults = result.data
                  this.filteredResults = this.searchResults
                }
              })
              .finally(() =>{
                this.loadingResults = false
                if(this.searchResults.length > 0) {
                  this.searchActive = true
                }
              })
        } else if(val.length > 3 && this.searchResults.length > 0) {
          this.filteredResults = []
          this.searchResults.forEach((obj) => {
            if(obj.itemNo.includes(val) ||
                obj.description.toLocaleLowerCase().includes(val.toLocaleLowerCase()))
            {
              this.filteredResults.push(obj)
            }
          })

          //Check if search returned any matches, if not start fuzzysearch

          if(this.filteredResults.length === 0) {
            this.filteredResults.push({header: 'Keine Produkte gefunden. Meintest du vielleicht?'})
            this.filteredResults = this.searchResults
            /*
            this.searchResults.forEach((obj) => {
              if(jaroWinkler(obj.itemNo, val) > 0.35
                  || jaroWinkler(obj.description.toLocaleLowerCase(), val.toLocaleLowerCase()) > 0.35)

              {
                this.filteredResults.push(obj)
              }
            })
            */
          }

        } else if(val.length < 3) {
          this.searchResults = []
          this.filteredResults= []
          this.searchActive = false
          this.loadingResults = false
        }
      }

      else if(this.queryGTIN) {
        this.requiredChars = 7
        if(val.length >= 7) {
          let param = val
          setTimeout(() => {
            if(param === this.search) {
              this.loadingResults = true
              axios.get('/api/products/searchGTIN/'+ val)
                  .then((result) => {
                    if(result.data.length === 0) {
                      this.filteredResults = []
                      this.filteredResults.push({header: 'Keine Produkte gefunden. Meintest du vielleicht?'})
                    }
                    else {
                      this.searchResults = result.data
                      this.filteredResults = this.searchResults
                    }
                  })
                  .finally(() =>{
                    this.loadingResults = false
                    if(this.searchResults.length > 0) {
                      this.searchActive = true
                    }
                  })
            }
          }, 500)
        }
        else if(val.length < 7) {
          this.searchResults = []
          this.filteredResults= []
          this.searchActive = false
          this.loadingResults = false
        }
      }

    },

    searchProduct() {
      let type = typeof this.searchField
      let articleNr = this.searchField.itemNo

      if(type === "object") {
        if(articleNr !== null) {
          router.push({name: 'Artikeldetails', params: {id: articleNr}})
          this.closeScanner()
        }
      }
      else if(type === 'string') {
        if(this.filteredResults.length === null) {
          this.setSearchResultsArticles(this.filteredResults)
          this.setCurrentPosition(null)
          router.push({name: 'Artikelergebnisse', params: {searchTerm: this.search, queryGTIN: this.queryGTIN}})
        }
        else if(this.filteredResults.length === 1) {
          router.push({name: 'Artikeldetails', params: {id: this.filteredResults[0]['itemNo']}})
        }
        else {
          this.setSearchResultsArticles(this.filteredResults)
          this.setCurrentPosition(null)
          router.push({name: 'Artikelergebnisse', params: {searchTerm: this.search, queryGTIN: this.queryGTIN}})
        }
        this.closeScanner()
      }
    },

    applyTorch() {
      const video = document.querySelector('video').srcObject
      const track = video.getVideoTracks()[0]

      if(!this.torchActive) {
        track.applyConstraints({
          advanced: [{torch: true}]
        })
      }
      else {
        track.applyConstraints({
          advanced: [{torch: false}]
        })
      }
    },

    async generateDeviceDate(devices) {
      let deviceId= null
      let focusDistance = null
      let cameraData = []

      for(const device of devices) {
        if(device['kind'] === 'videoinput') {
          const mediaStream = await navigator.mediaDevices.getUserMedia({video: {deviceId: device['deviceId']}}).catch((e) => {
            console.log(e)
            this.scannerAvailable = false
          })
          document.querySelector('video').srcObject = mediaStream

          const track = mediaStream.getVideoTracks()[0]
          const capabilities = track.getCapabilities()

          cameraData.push(capabilities)
          let keys = Object.keys(capabilities)
          if(keys.indexOf('focusMode') > -1 && keys.indexOf('facingMode') > 1) {
            if(capabilities['focusMode'].indexOf('continuous') > -1 && capabilities['facingMode'].indexOf('environment') > -1) {
              if(capabilities['focusDistance'] !== undefined) {
                let currentFocusDistance = capabilities['focusDistance']['max']
                if(focusDistance === null) {
                  focusDistance = currentFocusDistance
                  deviceId = device['deviceId']
                }
                else if(focusDistance !== null && (focusDistance > currentFocusDistance)) {
                  focusDistance = currentFocusDistance
                  deviceId = deviceId['deviceId']
                }
              }
              else {
                deviceId = device['deviceId']
              }
            }
          }
          await track.stop()


          /*
          await navigator.mediaDevices.getUserMedia({video: {deviceId: device['deviceId']}})
              .then(async mediaStream => {
                document.querySelector('video').srcObject = mediaStream

                const track = mediaStream.getVideoTracks()[0]
                const capabilities = track.getCapabilities()

                cameraData.push(capabilities)
                let keys = Object.keys(capabilities)
                if(keys.indexOf('focusMode') > -1 && keys.indexOf('facingMode') > 1) {
                  if(capabilities['focusMode'].indexOf('continuous') > -1 && capabilities['facingMode'].indexOf('environment') > -1) {
                    if(capabilities['focusDistance'] !== undefined) {
                      let currentFocusDistance = capabilities['focusDistance']['max']
                      if(focusDistance === null) {
                        focusDistance = currentFocusDistance
                        deviceId = device['deviceId']
                      }
                      else if(focusDistance !== null && (focusDistance > currentFocusDistance)) {
                        focusDistance = currentFocusDistance
                        deviceId = deviceId['deviceId']
                      }
                    }
                    else {
                      deviceId = device['deviceId']
                    }
                  }
                }

                await track.stop()
              }).catch((e) => {
                console.log(e)
                this.scannerAvailable = false
              })
          */
        }
      }


      /*
      cameraData.push(deviceId)


      let params = {log: cameraData}
      axios.post('api/sendCameraLog', params)
        .then((r) => {
          console.log(r)
        })
      */
      return deviceId
    },

    startScanner() {
      this.scannerAvailable = true
      this.gtinArray.length = 0

      if(this.searchField !== '' || this.searchField !== null) {
        this.searchField = ''
      }
      this.initializeScanner()
    },

    async initializeScanner() {
      const target = document.querySelector('#scannerWrapper')

      if (!target) {
        console.error('scannerWrapper not found')
        this.scannerAvailable = false
        return
      }


      const isIOS = this.isIOS()
      const isAndroid = this.isAndroid()
      let constraints
      if (isIOS) {
        constraints = {
          facingMode: { ideal: "environment" },
          width: { ideal: 1280, max: 1920 },
          height: { ideal: 720, max: 1080 },
          aspectRatio: { ideal: 16 / 9 },
          frameRate: { ideal: 25, max: 30 },
        }
      } else if(isAndroid) {
        try {
          const devices = await navigator.mediaDevices.enumerateDevices()
          let videoDevices = devices.filter(d => d.kind === 'videoinput')

          let backCamDevices = videoDevices.filter(d => /back|rear|environment/i.test(d.label))

          let backCam
          let storedCameraDevice = localStorage.getItem('cameraDevice')
          if(storedCameraDevice) {
            storedCameraDevice = JSON.parse(storedCameraDevice)
          }

          const camDevicePresentInDevices =
            storedCameraDevice &&
            devices.some(d => d.deviceId === storedCameraDevice.deviceId)

          if(!camDevicePresentInDevices) {
            for (let backCamDev of backCamDevices) {
              const mediaStream = await navigator.mediaDevices.getUserMedia({video: {deviceId: backCamDev['deviceId']}})
              const track = mediaStream.getVideoTracks()[0]
              const capabilities = track.getCapabilities()
              if(capabilities['focusMode'].indexOf('continuous') > -1) {
                backCam = backCamDev
              } else if(!backCam) {
                // forces default to last
                backCam = backCamDev
              }
              track.stop()
              localStorage.setItem('cameraDevice', JSON.stringify(backCam))
            }
          } else {
            backCam = storedCameraDevice
          }

          if (!backCam && videoDevices.length) {
            // fallback: last camera is often the rear on many devices
            backCam = videoDevices[videoDevices.length - 1]
          }

          if (backCam) {
            constraints = {
              deviceId: { exact: backCam.deviceId },
              width: { ideal: 1280 },
              height: { ideal: 720 },
              frameRate: { max: 30 },
            }
          } else {
            // no specific camera found, fall back to generic
            constraints = {
              facingMode: "environment",
              width: { min: 640 },
              height: { min: 480 },
              frameRate: { max: 30 },
            }
          }
        } catch (e) {
          console.warn('enumerateDevices failed, using generic constraints', e)
          constraints = {
            facingMode: "environment",
            width: { min: 640 },
            height: { min: 480 },
            frameRate: { max: 30 },
          }
        }
      } else {
        // other platforms / fallback
        constraints = {
          facingMode: "environment",
          width: { min: 640 },
          height: { min: 480 },
          frameRate: { max: 30 },
        }
      }

      await Quagga.init({
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: document.querySelector('#scannerWrapper'),
          constraints: constraints,
          area: {
            top: "25%",
            bottom: "25%",
            left: "10%",
            right: "10%",
          },
        },
        decoder: {
          readers: ['ean_reader', 'ean_8_reader'],
          multiple: false,
        },
        locator: {
          halfSample: true,
          patchSize: "medium",
        },
        frequency: 10,
        numOfWorkers: 0,
      }, (err) => {
        if (err) {
          console.error('Quagga init error', err)
          this.scannerAvailable = false
          return
        }

        // Fix for some iOS video quirks in PWAs:
        const video = target.querySelector('video')
        if (video) {
          video.setAttribute('playsinline', 'true')
          video.setAttribute('autoplay', 'true')
          video.muted = true
          // Try to kick playback if Safari PWA is being stubborn:
          const playPromise = video.play?.()
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(e => console.warn('Video play blocked:', e))
          }
        }

        Quagga.start()
        if (isAndroid) {
          this.enableContinuousFocus(target)
        }
      })

      // keep your onDetected as-is:
      Quagga.onDetected((result) => {
        let articleNr = result.codeResult.code
        this.gtinArray.push(articleNr)

        if (!this.detected && this.gtinArray.length > 10) {
          this.detected = true
          articleNr = this.gtinArray
            .sort((a, b) =>
              this.gtinArray.filter(v => v === a).length -
              this.gtinArray.filter(v => v === b).length
            )
            .pop()

          let params = { artNr: articleNr }

          axios.post('/api/scannerGTIN', params)
            .then((result) => {
              if (this.getUserRole() !== '2') {
                Quagga.stop()
                this.closeScanner()
                if (result.data.length > 0) {
                  this.$router.push({ path: `/shop/article/${result.data}` })
                } else {
                  this.$router.push({ path: `/shop/article/null` })
                }
              } else {
                axios.get('/api/products/' + result.data)
                  .then((result) => {
                    if (result.data.length > 0) {
                      this.article = result.data[0]
                    }
                  })
              }
            })
        }
      })

      // (Optional but helpful) Log whether frames are processed at all:
      Quagga.onProcessed(() => {
        // comment this out later
        // console.log('processed frame', !!data)
      })
    },

    enableContinuousFocus(target) {
      try {
        const video = target.querySelector('video')
        if (!video) return

        const stream = video.srcObject
        if (!stream) return

        const track = stream.getVideoTracks && stream.getVideoTracks()[0]
        if (!track || !track.getCapabilities) return

        const caps = track.getCapabilities()

        // some Androids expose focusMode, some don't
        const advanced = []

        if (caps.focusMode && caps.focusMode.includes('continuous')) {
          advanced.push({ focusMode: 'continuous' })
        } else if (caps.focusMode && caps.focusMode.includes('auto')) {
          advanced.push({ focusMode: 'auto' })
        }

        // optional: you can also set zoom here if available, etc.

        if (advanced.length) {
          track.applyConstraints({ advanced })
            .catch(e => console.warn('applyConstraints for focus failed:', e))
        }
      } catch (e) {
        console.warn('enableContinuousFocus error', e)
      }
    },

    addAndRestartScanner() {
      let newDeposit = {artNr: this.article.artNr,
                        name: this.article.name,
                        depositAmount: this.counter,
                        depositType: this.selection,
                        amountIfCrate: this.article.amount,
                        internalDepositType: this.article.deposit
      }
      this.counter = 1
      this.selection = undefined
      this.setDepositCollector(newDeposit)
      this.detected = false
    },

    increment() {
      this.counter += 1
    },
    decrement() {
      this.counter > 1 ? this.counter -= 1 : this.counter = 1
    },
    checkAmount: function(){
      if(this.counter < 1){
        this.counter = 1
      }
    },


  },
  computed: {
    ...mapGetters({
      getBarcodeScannerState: 'getBarcodeScannerState',
      getPermissions: 'getPermissions'
    }),

    termState() {
      if(this.termCounter > 0 && (this.termCounter < this.requiredChars)) {
        return this.termCounter+'/'+this.requiredChars
      }
      else {
        return ''
      }

    }
  },

  watch: {
    search(val) {
      if(val !== null || val !== '' && typeof val !== 'object') {
        if(this.getBarcodeScannerState) {
          this.searchProducts(val)
          this.termCounter = val.length
        }
      }
    },

    getBarcodeScannerState: {
      handler(role) {
        if(role) {
          this.queryGTIN = this.getPermissions.indexOf('LAGER') > -1
          this.startScanner()
        }
      }
    },

    searchField(val) {
      let type = typeof val
      if(this.getBarcodeScannerState) {
        if (type === 'object' && val !== null) {
          let itemNo = this.searchField.itemNo
          this.closeScanner()
          this.$router.push({path: `/shop/article/${itemNo}`})
        }
      }
      this.searchActive = false
    }
  },
}
</script>

<style>
  .camNotAvailable {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .camNotAvailable div {
    margin: auto;
    display: flex;
    flex-direction: column;
    height: 40%;
  }

  .camNotAvailable svg {
    transform: scale(1.5);
    margin: auto;
  }
</style>
